export default {
  "ask-quote": "Demander un devis",
  "department-action": "Départements d'action",
  "not-specified": "Non renseigné",
  about: {
    "company-values": "Valeurs de l'entreprise",
    subtitle: "À propos de",
  },
  documents: {
    title: "Nos documents officiels",
    insurance: "Assurance",
  },
  department: {
    hero: {
      "service-page-header": {
        verified: "Installateur verifié",
        certification: "Certification",
      },
    },
  },
  profile: {
    header: {
      title: "Provence Energie solaire services",
      subtitle: "Lorem ipsum dolor sit amet consectuar gernat",
    },
    about: "A propos",
    "all-about": "Tout savoir sur",
    "head-office": "Siège social",
    hire: "Engager installateur",
    "founded-date": "Date de fondation",
    employees: "Employés",
    departments: "Départements",
  },
}
